import { uniqBy, prop, update } from 'ramda';
const useEditFindingMultiSelect = ({ allAvailableOptions, selectedOptions, setSelected, }) => {
    const multiSelectOptions = selectedOptions.map((selectedOption) => ({
        selectedOption,
        availableForThisField: allAvailableOptions.filter((available) => available.id === selectedOption.id ||
            !selectedOptions.some((selected) => selected.id === available.id)),
    }));
    const onAdd = () => {
        const unselected = allAvailableOptions.filter((available) => !selectedOptions.some((selected) => selected.id === available.id));
        if (!unselected.length)
            return;
        setSelected(uniqBy(prop('id'), [...selectedOptions, unselected[0]]));
    };
    const onSelected = (currentValue, newValue) => {
        if (selectedOptions.some(({ id }) => id === newValue))
            return;
        const foundIndex = selectedOptions.findIndex((option) => option.id === currentValue);
        if (foundIndex === -1)
            return;
        setSelected(update(foundIndex, { ...selectedOptions[foundIndex], id: newValue }, selectedOptions));
    };
    const onRemove = (option) => {
        setSelected(selectedOptions.filter((item) => item.id !== option.id));
    };
    return { multiSelectOptions, onAdd, onSelected, onRemove };
};
export default useEditFindingMultiSelect;
